/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Leistungsbescheiderhalten1Inputs */

const de__field_leistungsbescheiderhalten1 = /** @type {(inputs: _Field_Leistungsbescheiderhalten1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leistungsbescheid erhalten`)
};

/**

* @param {_Field_Leistungsbescheiderhalten1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_leistungsbescheiderhalten1 = /** @type {((inputs?: _Field_Leistungsbescheiderhalten1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Leistungsbescheiderhalten1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_leistungsbescheiderhalten1(inputs)
});
export { _field_leistungsbescheiderhalten1 as "_field_leistungsbescheidErhalten" }